import { useParams } from "react-router-dom";
import { useDropsPageQuery } from "src/components/drops/DropsPage.generated";
import { DropsPageView } from "src/components/drops/DropsPageView";
import { useDocumentTitle } from "src/hooks/useDocumentTitle";
import { DevelopmentParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";

export function DevelopmentDropsPage() {
  const { developmentId } = useParams<DevelopmentParams>();
  const query = useDropsPageQuery({ variables: { filter: { development: [developmentId] }, entityId: developmentId } });
  useDocumentTitle("Development Drops");
  return queryResult(query, { data: ({ drops }) => <DropsPageView drops={drops} /> });
}
